import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { WindowRef } from '../../providers/window-ref';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { AppService } from '../../providers/app.service';
import { trigger, style, animate, transition } from '@angular/animations';
import { routerTransition } from '../../router.animations';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    animations: [
        routerTransition(),
        trigger('fadeInOut', [
            transition('void => *', [
                style({ opacity: 0 }),
                animate(500, style({ opacity: 1 }))
            ]),
            transition('* => void', [
                animate(500, style({ opacity: 0 }))
            ])
        ])
    ],
    host: { '[@routerTransition]': '' }
})

export class HomeComponent implements OnInit, AfterViewInit {
    @ViewChild('videoplayer') videoPlayer;
    fragment: string;
    platformFeatures: Array<any> = [];
    baseUrl: string = environment.baseUrl;
    homepage: any = {};
    homepageSlides: Array<any> = null;
    articles: Array<any> = null;
    config: any = {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplay: 4000,
        speed: 1200,
        effect: 'coverflow',
        disableOnInteraction: false,
    };
    menu: any = {};
    msnry: any = null;
    galleryPictures: Array<any> = null;
    language: string;
    contactName: string;
    contactEmail: string;
    contactMessage: string;
    errors: any = {
        none: false,
        generic: false,
        fields: false,
        email: false,
    }
    videoPlaying: boolean = false;

    constructor(private route: ActivatedRoute, private router: Router, private winRef: WindowRef, private appService: AppService) {
    }

    ngOnInit() {
        this.route.data
            .subscribe(data => {
                this.homepage = data.homepageData.homepage;
                this.platformFeatures = data.homepageData.platformFeatures;
                this.homepageSlides = data.homepageData.homepageSlides;
                this.galleryPictures = data.homepageData.galleryPictures;
                this.articles = data.homepageData.articles;
                this.menu = data.homepageData.menu;
            });
        this.route.paramMap.subscribe((params: ParamMap) => {
            this.language = params.get('language');
        });
        this.route.fragment.subscribe(fragment => { this.fragment = fragment; });
    }

    displayConfirmation(result) {
        this.errors[result] = true;
        setTimeout(() => {
            this.errors[result] = false;
        }, 3000);
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    sendMessage() {
        if (!this.contactName || !this.contactEmail || !this.contactMessage) {
            this.displayConfirmation('fields');
        } else {
            if (!this.validateEmail(this.contactEmail)) {
                return this.displayConfirmation('email');
            }
            this.appService.getXCSRFToken().subscribe(data => {
                let token = data.text();
                this.appService.sendContactMessage(token, this.contactName, this.contactEmail, this.contactMessage).subscribe(data => {
                    if (data.status === 201) {
                        this.displayConfirmation('none');
                    } else {
                        this.displayConfirmation('generic');
                    }
                });
            }, error => {
                this.displayConfirmation('generic');
            });
        }
    }

    playVideo() {
        if (this.videoPlaying) {
            this.videoPlayer.nativeElement.pause();
        } else {
            this.videoPlayer.nativeElement.play();
        }
        this.videoPlaying = !this.videoPlaying;
    }

    ngAfterViewInit() {
        this.initMasonry();
        this.initPhotoswipe();
        this.initParallax();
        try {
            if (this.fragment) {
                document.querySelector('#' + this.fragment).scrollIntoView();
            }
        } catch (e) {
            console.log(e);
        }
    }

    initParallax() {
        this.winRef.nativeWindow.jQuery('.parallax').parallax();
    }

    initMasonry() {
        let elem = document.querySelector('.grid');
        this.msnry = new this.winRef.nativeWindow.Masonry(elem, {
            itemSelector: '.blockPicture',
            isAnimated: true,
            animationOptions: {
                duration: 700,
                easing: 'linear',
                queue: false
            }
        });
    }

    galleryImageLoaded() {
        if (this.msnry) {
            this.msnry.layout();
        }
    }

    initPhotoswipe() {
        let winRef: any = this.winRef;
        var initPhotoSwipeFromDOM = function (gallerySelector) {
            var parseThumbnailElements = function (el) {
                var thumbElements = el.childNodes,
                    numNodes = thumbElements.length,
                    items = [],
                    el,
                    childElements,
                    thumbnailEl,
                    size,
                    item;

                for (var i = 0; i < numNodes; i++) {
                    el = thumbElements[i];

                    // include only element nodes
                    if (el.nodeType !== 1) {
                        continue;
                    }

                    childElements = el.children;

                    size = el.getAttribute('data-size').split('x');

                    // create slide object
                    item = {
                        src: el.getAttribute('href'),
                        w: parseInt(size[0], 10),
                        h: parseInt(size[1], 10),
                        author: el.getAttribute('data-author')
                    };

                    item.el = el; // save link to element for getThumbBoundsFn

                    if (childElements.length > 0) {
                        item.msrc = childElements[0].getAttribute('src'); // thumbnail url

                        if (childElements.length > 1) {
                            item.title = childElements[1].innerHTML; // caption (contents of figure)
                        }
                    }

                    // original image
                    item.o = {
                        src: item.src,
                        w: item.w,
                        h: item.h
                    };

                    items.push(item);
                }

                return items;
            };

            // find nearest parent element
            var closest = function closest(el, fn) {
                return el && (fn(el) ? el : closest(el.parentNode, fn));
            };

            var onThumbnailsClick = function (e) {
                e = e || window.event;
                e.preventDefault ? e.preventDefault() : e.returnValue = false;

                var eTarget = e.target || e.srcElement;

                var clickedListItem = closest(eTarget, function (el) {
                    return el.tagName === 'A';
                });

                if (!clickedListItem) {
                    return;
                }

                var clickedGallery = clickedListItem.parentNode;

                var childNodes = clickedListItem.parentNode.childNodes,
                    numChildNodes = childNodes.length,
                    nodeIndex = 0,
                    index;

                for (var i = 0; i < numChildNodes; i++) {
                    if (childNodes[i].nodeType !== 1) {
                        continue;
                    }

                    if (childNodes[i] === clickedListItem) {
                        index = nodeIndex;
                        break;
                    }
                    nodeIndex++;
                }

                if (index >= 0) {
                    openPhotoSwipe(index, clickedGallery, false, false);
                }
                return false;
            };

            var photoswipeParseHash = function () {
                var hash = window.location.hash.substring(1),
                    params: any = {};

                if (hash.length < 5) { // pid=1
                    return params;
                }

                var vars = hash.split('&');
                for (var i = 0; i < vars.length; i++) {
                    if (!vars[i]) {
                        continue;
                    }
                    var pair = vars[i].split('=');
                    if (pair.length < 2) {
                        continue;
                    }
                    params[pair[0]] = pair[1];
                }

                if (params.gid) {
                    params.gid = parseInt(params.gid, 10);
                }

                return params;
            };

            var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
                var pswpElement = document.querySelectorAll('.pswp')[0],
                    gallery,
                    options,
                    items;

                items = parseThumbnailElements(galleryElement);

                // define options (if needed)
                options = {

                    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

                    getThumbBoundsFn: function (index) {
                        // See Options->getThumbBoundsFn section of docs for more info
                        var thumbnail = items[index].el.children[0],
                            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                            rect = thumbnail.getBoundingClientRect();

                        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
                    },

                    addCaptionHTMLFn: function (item, captionEl, isFake) {
                        if (!item.title) {
                            captionEl.children[0].innerText = '';
                            return false;
                        }
                        captionEl.children[0].innerHTML = item.title + '<br/><small>Photo: ' + item.author + '</small>';
                        return true;
                    },

                };


                if (fromURL) {
                    if (options.galleryPIDs) {
                        // parse real index when custom PIDs are used
                        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                        for (var j = 0; j < items.length; j++) {
                            if (items[j].pid == index) {
                                options.index = j;
                                break;
                            }
                        }
                    } else {
                        options.index = parseInt(index, 10) - 1;
                    }
                } else {
                    options.index = parseInt(index, 10);
                }

                // exit if index not found
                if (isNaN(options.index)) {
                    return;
                }

                options.mainClass = 'pswp--minimal--dark';
                options.barsSize = { top: 0, bottom: 0 };
                options.captionEl = false;
                options.fullscreenEl = false;
                options.shareEl = false;
                options.bgOpacity = 0.85;
                options.tapToClose = true;
                options.tapToToggleControls = false;

                if (disableAnimation) {
                    options.showAnimationDuration = 0;
                }

                // Pass data to PhotoSwipe and initialize it
                gallery = new winRef.nativeWindow.PhotoSwipe(pswpElement, winRef.nativeWindow.PhotoSwipeUI_Default, items, options);

                // see: http://photoswipe.com/documentation/responsive-images.html
                var realViewportWidth,
                    useLargeImages = false,
                    firstResize = true,
                    imageSrcWillChange;

                gallery.listen('beforeResize', function () {

                    var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
                    dpiRatio = Math.min(dpiRatio, 2.5);
                    realViewportWidth = gallery.viewportSize.x * dpiRatio;


                    if (realViewportWidth >= 1200 || (!gallery.likelyTouchDevice && realViewportWidth > 800) || screen.width > 1200) {
                        if (!useLargeImages) {
                            useLargeImages = true;
                            imageSrcWillChange = true;
                        }

                    } else {
                        if (useLargeImages) {
                            useLargeImages = false;
                            imageSrcWillChange = true;
                        }
                    }

                    if (imageSrcWillChange && !firstResize) {
                        gallery.invalidateCurrItems();
                    }

                    if (firstResize) {
                        firstResize = false;
                    }

                    imageSrcWillChange = false;

                });

                gallery.listen('gettingData', function (index, item) {
                    if (useLargeImages) {
                        item.src = item.o.src;
                        item.w = item.o.w;
                        item.h = item.o.h;
                    }
                });
                gallery.init();
            };

            // select all gallery elements
            var galleryElements = document.querySelectorAll(gallerySelector);
            for (var i = 0, l = galleryElements.length; i < l; i++) {
                galleryElements[i].setAttribute('data-pswp-uid', i + 1);
                galleryElements[i].onclick = onThumbnailsClick;
            }

            // Parse URL and open gallery if it contains #&pid=3&gid=1
            var hashData = photoswipeParseHash();
            if (hashData.pid && hashData.gid) {
                openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
            }
        };

        initPhotoSwipeFromDOM('.grid-picture');
    }

}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts